import { Card, Label, TextArea, Tooltip } from '@iwoca/orion';
import { PURPOSEOPTIONS } from 'components/addNewApplication/PurposeOfFundsHelper';
import { TLoanPurpose } from 'lendingApi/applications.types';
import tradingHistoryStyles from '../TradingHistory.module.css';
import styles from './LoanPurposeDetails.module.css';

type TProps = {
  purpose: TLoanPurpose;
  purposeDetails: string;
  setPurposeDetails: (details: string) => void;
};

export const LoanPurposeDetails = ({
  purpose,
  purposeDetails,
  setPurposeDetails,
}: TProps) => {
  const loanPurpose = PURPOSEOPTIONS().find(
    (option) => option.value === purpose,
  );

  if (!loanPurpose) {
    return null;
  }

  const defaultDescription =
    'Please provide any extra details on what the funds will be used for.';

  const description = `${
    loanPurpose.description || defaultDescription
  } (optional)`;

  return (
    <Card className={styles.card}>
      <h2 className={tradingHistoryStyles.cardHeading}>
        Loan purpose: <span>{loanPurpose.label}</span>
      </h2>
      <div className={styles.labelWithTooltip}>
        <Label htmlFor="loanPurposeDetails">Purpose details</Label>
        <Tooltip
          dataTestId="loan-purpose-tooltip"
          content="Detailed information will lead to faster decisions."
        />
      </div>
      <div className={styles.textAreaContainer}>
        <TextArea
          data-testid="loan-purpose-details-input"
          className={styles.textArea}
          id="loanPurposeDetails"
          description={description}
          value={purposeDetails}
          onChange={(e) => setPurposeDetails(e.target.value)}
        />
      </div>
    </Card>
  );
};
